import {
  GETSALESORDERSDETAILS,
  CREATESALESORDERS,
  GETSALESORDERS,
  DELETESALESORDERS,
  UPDATESALESORDERS,
  CREATESALESORDERSITEM,
  CREATESALESORDERSREFRENCE,
  GETALLSALESORDERSDATA,
  UPDATESALESORDERSITEM,
  GETALLLOGESALESORDERSDATA,
  GETPRODUCTPACKAGERELATION,
  CREATESALESORDERRECIPT,
  UPDATESALESITEM,
  DELETELOGESALESITEM,
  UPDATELOGESALESITEM,
  CREATEREVERSESALESORDERS,
  UPDATEBULKMODULECHILREN,
  DELETELOGESALESITEMBYID,
  axios,
  baseURL,
} from "./types";

export const createSalesOrders = (data) => (dispatch) => {
  console.log("Action: createSalesOrders payload ->", data);
  var config = {
    method: "post",
    url: baseURL + "/api/setupsalesorders/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: CREATESALESORDERS,
        payload: response.data,
      });

      return response;
    })
    .catch(function (error) {
      console.error("Error in createSalesOrders action:", error);

      throw error;
    });
};

export const getSalesOrders = (data) => async (dispatch) => {
  console.log("Action: getSalesOrders payload ->", data);

  const config = {
    method: "post",
    url: baseURL + "/api/setupsalesorders/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  try {
    const response = await axios(config);
    return dispatch({
      type: GETSALESORDERS,
      payload: response.data,
    });
  } catch (error) {
    console.error("Error in getSalesOrders:", error);
  }
};

export const getSalesOrdersDetails = (data) => async (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setupsalesorders/getdetails",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  try {
    const response = await axios(config);
    return dispatch({
      type: GETSALESORDERSDETAILS,
      payload: response.data,
    });
  } catch (error) {
    console.error("Error in getSalesOrders:", error);
  }
};

export const updateSalesOrders = (data) => (dispatch) => {
  console.log("Action: updateSalesOrders payload ->", data);
  var config = {
    method: "patch",
    url: baseURL + "/api/setupsalesorders/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATESALESORDERS,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.error("Error in updateSalesOrders action:", error);
      throw error;
    });
};

export const deleteSalesOrders = (data) => (dispatch) => {
  console.log("Action: deleteSalesOrders payload ->", data);
  var config = {
    method: "delete",
    url: baseURL + "/api/setupsalesorders/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: DELETESALESORDERS,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.error("Error in deleteSalesOrders action:", error);
      throw error;
    });
};

export const createSalesOrdersItem = (data) => (dispatch) => {
  console.log("Action: createSalesOrders payload ->", data);
  var config = {
    method: "post",
    url: baseURL + "/api/LogeSalesOrdersItem/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: CREATESALESORDERSITEM,
        payload: response.data,
      });

      return response;
    })
    .catch(function (error) {
      console.error("Error in createSalesOrderItem action:", error);

      throw error;
    });
};

export const createSalesOrdersRefrence = (data) => (dispatch) => {
  console.log("Action: createSalesOrders payload ->", data);
  var config = {
    method: "post",
    url: baseURL + "/api/LogesalesorderRef/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: CREATESALESORDERSREFRENCE,
        payload: response.data,
      });

      return response;
    })
    .catch(function (error) {
      console.error("Error in createSalesOrdersrEF action:", error);

      throw error;
    });
};

export const getAllSalesOrderData = (data) => async (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/setupsalesorders/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  try {
    const response = await axios(config);
    return dispatch({
      type: GETALLSALESORDERSDATA,
      payload: response.data,
    });
  } catch (error) {
    console.error("Error in getSalesOrders:", error);
  }
};

export const updateAllSalesOrderItems = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/LogeSalesOrdersItem/updatebysale",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATESALESORDERSITEM,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.error("Error in updateSalesOrders action:", error);
      throw error;
    });
};

export const getlogeSalesOrderData = (data) => async (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/LogeSalesOrdersItem/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  try {
    const response = await axios(config);
    return dispatch({
      type: GETALLLOGESALESORDERSDATA,
      payload: response.data,
    });
  } catch (error) {
    console.error("Error in getSalesOrders:", error);
  }
};

export const getProductPackageRelation = (data) => async (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/hospitalProductPackageRelation/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  try {
    const response = await axios(config);
    return dispatch({
      type: GETPRODUCTPACKAGERELATION,
      payload: response.data,
    });
  } catch (error) {
    console.error("Error in getSalesOrders:", error);
  }
};

export const updateSalesOrderItems = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/LogeSalesOrdersItem/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: "UPDATESALESITEM",
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.error("Error in updateSalesOrderItems action:", error);
      throw error;
    });
};

export const createSalesOrdersRecipt = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupsalesorders/recipt",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: CREATESALESORDERRECIPT,
        payload: response.data,
      });

      return response;
    })
    .catch(function (error) {
      console.error("Error in createSalesOrdersrEF action:", error);

      throw error;
    });
};

export const updateSalesOrdersItem = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/LogeSalesOrdersItem/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: "UPDATELOGESALESITEM",
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.error("Error in updateSalesOrderItems action:", error);
      throw error;
    });
};

export const deleteSalesOrdersItem = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/LogeSalesOrdersItem/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: "DELETELOGESALESITEM",
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.error("Error in deleteSalesOrdersItem action:", error);
      throw error;
    });
};

export const retryProvisioning = (data) => (dispatch) => {
  console.log("Action: retryProvisioning payload ->", data);
  var config = {
    method: "post",
    url: baseURL + "/api/setupsalesorders/retry-provisioning",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.error("Error in retryProvisioning action:", error);
      throw error;
    });
};

export const createReverseSalesOrders = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupsalesorders/reversesale",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEREVERSESALESORDERS,
        payload: response.data,
      });

      return response;
    })
    .catch(function (error) {
      console.error("Error in createSalesOrders action:", error);

      throw error;
    });
};

export const updatebulkmodulechild = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setupmodule/updatestatus",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEBULKMODULECHILREN,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.error("Error in updatebulkmodulechild action:", error);
      throw error;
    });
};

export const deleteSalesOrdersItemById = (data) => (dispatch) => {
  const parsedData = JSON.parse(data);
  const deletedId = parsedData.id;

  var config = {
    method: "delete",
    url: baseURL + "/api/LogeSalesOrdersItem/deletebyid",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: "DELETELOGESALESITEMBYID",
        payload: {
          success: response.data.success,
          id: deletedId,
        },
      });
      return response;
    })
    .catch(function (error) {
      console.error("Error in deleteSalesOrdersItem action:", error);
      throw error;
    });
};
